module.exports = __webpack_public_path__ + "img/0x44754455564474a89358b2c2265883df993b12f0.7479589a.png";